import React from "react";
import {
  Outlet
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import "./style/responsive-fixes.css";

/* Network Hook */
import { useNetworkStatus } from "./hooks/useNetworkStatus";

import { SignalRProvider } from "./context/SignalRContext";
import NotificationListener from "./components/NotificationListener";
import ChatLayout from "./components/Chat/ChatLayout";
/* ================= LAYOUT ================= */
const AppLayout: React.FC<{ isAuthenticated: boolean }> = ({
  isAuthenticated,
}) => {
  const { isOnline, isSlow, connectionType } = useNetworkStatus();

  return (
    <>
      {/* 🌐 Network Banner */}
      <div className="network-status">
        {!isOnline && (
          <div className="internet-offline">
            🚫 No Internet Connection
          </div>
        )}

        {isOnline && isSlow && (
          <div className="internet-slow">
            ⚠ Slow Internet ({connectionType})
          </div>
        )}
      </div>

      {/* 🔌 SignalR */}
      <SignalRProvider isAuthenticated={isAuthenticated}>
        {isAuthenticated && <NotificationListener />}

        {/* 🔥 ROUTES RENDER HERE */}
        <Outlet />

        {/* 💬 Chat */}
        {/* {isAuthenticated && <ChatLayout />} */}
      </SignalRProvider>

      {/* 🔔 Toast */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        className="custom-toast"
      />
    </>
  );
};

export default AppLayout;